import { AccessLevel } from '@kcftech/prometheustypescriptapiclient';
import { useRouteEntities } from 'contexts/RouteEntityContext';
import { createContext, ReactNode, useContext, useMemo } from 'react';

export type AccessContext = Readonly<{
    /** True if selected Corporation is Premium Access Level */
    isPremium: boolean;
}>;

const Context = createContext<AccessContext>({
    isPremium: true,
});

export type AccessProviderProps = Readonly<{
    children: ReactNode;
}>;

export function AccessProvider({ children }: AccessProviderProps) {
    const { corporation } = useRouteEntities();

    const contextValue: AccessContext = useMemo(
        () => ({
            isPremium: corporation?.AccessLevel === AccessLevel.Premium,
        }),
        [corporation]
    );

    return <Context.Provider value={contextValue}>{children}</Context.Provider>;
}

export const useAccess = () => useContext(Context);
